/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Roomannouncementtoosoon3Inputs */

const en_roomannouncementtoosoon3 = /** @type {(inputs: Roomannouncementtoosoon3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next announcement possible in ${i?.minutes} min.`)
};

const de_roomannouncementtoosoon3 = /** @type {(inputs: Roomannouncementtoosoon3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nächste Ankündigung in ${i?.minutes} Min. möglich`)
};

/**
* | output |
* | --- |
* | "Next announcement possible in {minutes} min." |
*
* @param {Roomannouncementtoosoon3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementtoosoon3 = /** @type {((inputs: Roomannouncementtoosoon3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementtoosoon3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementtoosoon3(inputs)
	return de_roomannouncementtoosoon3(inputs)
});
export { roomannouncementtoosoon3 as "roomAnnouncementTooSoon" }